import * as React from "react";
import {cs} from "../../../../../../../react/chain-services";
import "./list-name-section.scss";
import {ErrorHighlighter} from "../../../../../../light/error-highlighter";
import {UseState} from "../../../../../../../react/use-state";
import {bindInput} from "../../../../../../../react/bind-input";
import {cx} from "emotion";
import {Checkbox} from "../../../../../common/design2/checkbox/checkbox";
import {TermsModal} from "./terms-modal/terms-modal";
import {formatNumberBig} from "../../../../../../language/format-number-big";

export const ListNameSection = ({data, name=undefined, next, xdQaName=undefined}) => cs(
    ["nameEH", (_, next) => ErrorHighlighter({next})],
    ["termsEH", (_, next) => ErrorHighlighter({next})],
    ["agreed", (_, next) => UseState({next})],
    ({nameEH, termsEH, agreed}) => next({
        invalid: !data.value || !agreed.value,
        highlightErrors: () => {
            if (!data.value) {
                nameEH.start();
            } else if (!agreed.value) {
                termsEH.start();
            }
        },
        render: ({showErrors, total=undefined}) => (
            <div className="list-name-section-0p0">
                <div className="left">
                    <div
                        className="title"
                        xd-qa-type="label"
                        xd-qa-name={xdQaName+" "+(name ? name+" List Name" : "List Name")}
                    >
                        {name} List Name
                    </div>
                    {total != null && (
                        <div
                            className="description"
                            xd-qa-type="label"
                            xd-qa-name={xdQaName+" "+(name ? name+" List Name Description" : "List Name Description")}
                        >
                            You’re about to order <span xd-qa-type="label" xd-qa-name={xdQaName+" List Quantity"}>{formatNumberBig(total)}</span> addresses.
                        </div>
                    )}
                </div>
                <div className="right">
                    <div className="name">
                        <input {...{
                            className: cx(nameEH.css, {hasError: showErrors && !data.value}),
                            placeholder: "Name of this address list...",
                            maxLength: 50,
                            ...bindInput(data),
                            "xd-qa-type": "text_field",
                            "xd-qa-name": xdQaName+" "+(name ? name+" List Name" : "List Name"),
                        }}/>
                    </div>

                    {cs(
                        ["termsModal", (_, next) => TermsModal({next})],
                        ({termsModal}) => (
                            <div
                                className={cx("terms", termsEH.css, {hasError: showErrors && !agreed.value})}
                                onClick={() => agreed.change((_) => !_)}
                            >
                                {Checkbox({
                                    checked: agreed.value,
                                    xdQaName: xdQaName+" Terms and Conditions"
                                })}

                                <div className="text" xd-qa-type="label" xd-qa-name={xdQaName+" Terms and Conditions"}>
                                    I agree with{" "}
                                    <a onClick={(e) => {
                                            e.stopPropagation();
                                            termsModal.show();
                                        }}
                                    xd-qa-type="link"
                                    xd-qa-name={xdQaName+" Terms and Conditions"}
                                    >
                                        terms and conditions
                                    </a>
                                </div>
                            </div>
                        )
                    )}
                </div>
            </div>
        ),
    }),
);